import { useState, useEffect } from "react";
import { usePageTracking } from "utils/userPageTracking";
import PropTypes from "prop-types";

function Tabs ({ tabs, initialTabLabel = "" }) {
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    setActiveTab((idx) => (idx < tabs.length ? idx : 0));
  }, [tabs.length]);

  useEffect(() => {
    if (!initialTabLabel) {
      return;
    }

    const requestedIndex = tabs.findIndex((tab) => tab.label === initialTabLabel);
    if (requestedIndex >= 0) {
      setActiveTab(requestedIndex);
    }
  }, [tabs, initialTabLabel]);

  const safeActiveTab = activeTab < tabs.length ? activeTab : 0;

const [tabLabel, setTabLabel] = useState("");

usePageTracking(tabLabel);

const handleTabClick = (index, tab) => {
  setActiveTab(index);

  if (tab.label === "TnT Linkage") {
    setTabLabel("TNT Linkage");
  } else if (tab.label === "Monitor Today") {
    setTabLabel("Monitor Today");
  } else if (tab.label === "Email HITL") {
    setTabLabel("Email HITL");
  }
};

  return (
    <div>
      {/* Tab Headers */}
      <div style={{ display: "flex", borderBottom: "2px solid #ddd" }}>
        {tabs.map((tab, index) => (
          <button
            key={tab.label}
            onClick={() => handleTabClick(index, tab)}
            style={{
                color: safeActiveTab === index ? "var(--primary-unilever-color)" : "#555",
              padding: "10px 16px",
              cursor: "pointer",
              background: "none",
              border: "none",   
              borderRadius: "0",    
              borderBottom:
                safeActiveTab === index ? "3px solid var(--primary-unilever-color)" : "none",
              fontWeight: safeActiveTab === index ? "600" : "400",
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div style={{ padding: "10px" }}>
        {tabs[safeActiveTab]?.content}
      </div>
    </div>
  );
}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      content: PropTypes.node,
    })
  ).isRequired,
  initialTabLabel: PropTypes.string,
};

export default Tabs;
